module.exports = __webpack_public_path__ + "static/img/twitter.677e372.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/twitter.png
// module id = ZKaF
// module chunks = 94